import {
  Box,
  HStack,
  Heading,
  Icon,
  ListItem,
  Spinner,
  Stack,
  Text,
  UnorderedList,
  VStack,
} from '@chakra-ui/react';
import React from 'react';
import Card from '../components/Card';
import { FiMail, FiPhone, FiUsers } from 'react-icons/fi';
import { useState } from 'react';
import { useEffect } from 'react';
import { securedAxiosInstance } from '../api/axios';

const Help = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [latestUpdates, setLatestUpdates] = useState([]);
  useEffect(() => {
    const getLatestDocs = async () => {
      setIsLoading(true);
      const res = await securedAxiosInstance.get('categories');
      setLatestUpdates(res.data);
      setIsLoading(false);
    };

    getLatestDocs();
  }, []);
  return (
    <VStack px={{ base: 4, md: 10 }} py={8} spacing={4}>
      <Box w={'full'}>
        <Heading>Help Centre</Heading>
      </Box>
      <Stack
        justifyContent={'space-between'}
        alignContent={'center'}
        direction={{ base: 'column', md: 'row' }}
        w={'full'}
        spacing={4}
      >
        <Card>
          <HStack mb={'2'}>
            <Text fontWeight="bold">Send us an email</Text>
          </HStack>
          <HStack>
            <Icon color={'primary'} as={FiMail} />
            <a href="mailto:info@oasispc.com.au">
              <Text
                fontWeight="semibold"
                color={'black'}
                _hover={{
                  color: 'primary',
                }}
              >
                info@oasispc.com.au
              </Text>
            </a>
          </HStack>
        </Card>
        <Card>
          <HStack mb={'2'}>
            <Text fontWeight="bold">Call us</Text>
          </HStack>
          <HStack>
            <Icon color={'primary'} as={FiPhone} />
            <a href="tel:1300 652 022">
              <Text
                fontWeight="semibold"
                color={'black'}
                _hover={{
                  color: 'primary',
                }}
              >
                1300 652 022
              </Text>
            </a>
          </HStack>
        </Card>
        <Card>
          <HStack mb={'2'}>
            <Text fontWeight="bold">Contact us</Text>
          </HStack>
          <HStack>
            <Icon color={'primary'} as={FiUsers} />
            <a href="https://oasispc.com.au/contact">
              <Text
                fontWeight="semibold"
                color={'black'}
                _hover={{
                  color: 'primary',
                }}
              >
                oasispc.com.au/contact
              </Text>
            </a>
          </HStack>
        </Card>
      </Stack>
      <Card mx={'auto'} flex={'1'} flexGrow={'1'} h={'full'}>
        <Stack
          w={'full'}
          h={'full'}
          spacing={{ base: 2, xl: 4 }}
          direction={'column'}
        >
          <Heading as="h3" size="md">
            LEARNING CENTRE
          </Heading>
          <Text fontSize={'md'}>
            Click{' '}
            <a href="https://learn.4boxes.com.au/">
              <Text
                as={'span'}
                color={'primary'}
                _hover={{
                  textDecoration: 'underline',
                }}
              >
                here
              </Text>
            </a>{' '}
            for a range of written and video support resources on:
          </Text>
          <UnorderedList stylePosition={'inside'}>
            {isLoading ? (
              <Spinner color="primary" />
            ) : latestUpdates.length > 0 ? (
              latestUpdates.map((update, i) => (
                <ListItem key={update.id}>
                  <Text as={'span'} color={'black'} fontSize={'md'}>
                    {update.name}
                  </Text>
                </ListItem>
              ))
            ) : (
              <ListItem>No updates yet.</ListItem>
            )}
          </UnorderedList>
          <Text fontWeight="400" fontSize="14px">
            <a
              href="https://oasispc.com.au/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              <Text color={'primary'} as="span">
                Privacy Policy
              </Text>
            </a>
          </Text>
        </Stack>
      </Card>
    </VStack>
  );
};

export default Help;
